import { render, staticRenderFns } from "./ItemManageView.vue?vue&type=template&id=69281913&"
import script from "./ItemManageView.vue?vue&type=script&lang=js&"
export * from "./ItemManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports